function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M16 3.2c.619 0 1.12.716 1.12 1.6V8c0 .884-.501 1.6-1.12 1.6-.619 0-1.12-.716-1.12-1.6V4.8c0-.883.501-1.6 1.12-1.6z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M22.4 4.915c.535.309.611 1.18.17 1.945l-1.6 2.772c-.441.765-1.233 1.135-1.77.826-.536-.309-.612-1.18-.17-1.946l1.6-2.771c.442-.766 1.234-1.136 1.77-.826z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.08333333333333333s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M27.085 9.6c.31.536-.06 1.328-.825 1.77l-2.771 1.6c-.766.442-1.637.366-1.945-.17-.31-.536.061-1.328.825-1.77l2.771-1.6c.764-.442 1.635-.366 1.945.17z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.16666666666666666s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M28.8 16c0 .619-.716 1.12-1.6 1.12H24c-.884 0-1.6-.501-1.6-1.12 0-.619.716-1.12 1.6-1.12h3.2c.884 0 1.6.501 1.6 1.12z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.25s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M27.085 22.4c-.31.535-1.181.611-1.945.17l-2.771-1.601c-.765-.441-1.135-1.233-.825-1.77.309-.536 1.18-.612 1.945-.17l2.771 1.6c.765.443 1.135 1.235.825 1.771z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.3333333333333333s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M22.4 27.085c-.536.31-1.328-.06-1.771-.825l-1.6-2.771c-.442-.766-.366-1.637.17-1.945.536-.31 1.328.061 1.77.825l1.601 2.771c.442.764.366 1.635-.17 1.945z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.4166666666666667s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M16 28.8c-.619 0-1.12-.716-1.12-1.6V24c0-.884.501-1.6 1.12-1.6.619 0 1.12.716 1.12 1.6v3.2c0 .884-.501 1.6-1.12 1.6z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.5s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M9.6 27.085c-.536-.31-.612-1.181-.17-1.945l1.6-2.771c.441-.765 1.234-1.135 1.77-.825.536.309.612 1.18.17 1.945l-1.6 2.771c-.442.765-1.234 1.135-1.77.825z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.5833333333333334s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M4.915 22.4c-.31-.536.06-1.328.826-1.771l2.771-1.6c.765-.442 1.636-.366 1.946.17.309.536-.061 1.328-.826 1.77L6.86 22.57c-.765.442-1.636.366-1.945-.17z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.6666666666666666s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M3.2 16c0-.619.716-1.12 1.6-1.12H8c.884 0 1.6.501 1.6 1.12 0 .619-.716 1.12-1.6 1.12H4.8c-.883 0-1.6-.501-1.6-1.12z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.75s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M4.915 9.6c.309-.536 1.18-.612 1.945-.17l2.771 1.6c.765.441 1.135 1.234.826 1.77-.31.536-1.181.612-1.946.17l-2.771-1.6c-.765-.442-1.135-1.234-.825-1.77z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.8333333333333334s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#03B8DF",
  d: "M9.6 4.915c.536-.31 1.328.06 1.77.826l1.6 2.771c.442.766.366 1.637-.17 1.946-.536.309-1.328-.061-1.77-.826L9.43 6.86c-.442-.765-.366-1.636.17-1.945z"
}, /*#__PURE__*/React.createElement("animate", {
  fill: "remove",
  restart: "always",
  calcMode: "linear",
  additive: "replace",
  accumulate: "none",
  repeatCount: "indefinite",
  begin: "0.9166666666666666s",
  dur: "1s",
  to: 0,
  from: 1,
  attributeName: "opacity"
}));

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default SvgLoading;